var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// Copyright (c) 2017 Uber Technologies, Inc.
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
// THE SOFTWARE.

import MathArray from './math-array';
import { checkNumber } from './common';

// gl-matrix is too big. Cherry-pick individual imports from stack.gl version
/* eslint-disable camelcase */
import vec3_set from 'gl-vec3/set';
import vec3_length from 'gl-vec3/length';
import vec3_distance from 'gl-vec3/distance';
import vec3_angle from 'gl-vec3/angle';
import vec3_add from 'gl-vec3/add';
import vec3_subtract from 'gl-vec3/subtract';
import vec3_multiply from 'gl-vec3/multiply';
import vec3_divide from 'gl-vec3/divide';
import vec3_scale from 'gl-vec3/scale';
import vec3_scaleAndAdd from 'gl-vec3/scaleAndAdd';
import vec3_negate from 'gl-vec3/negate';
import vec3_inverse from 'gl-vec3/inverse';
import vec3_normalize from 'gl-vec3/normalize';
import vec3_dot from 'gl-vec3/dot';
import vec3_cross from 'gl-vec3/cross';
import vec3_lerp from 'gl-vec3/lerp';
import vec3_rotateX from 'gl-vec3/rotateX';
import vec3_rotateY from 'gl-vec3/rotateY';
import vec3_rotateZ from 'gl-vec3/rotateZ';

var ORIGIN = [0, 0, 0];

export function validateVector3(v) {
  return v.length === 3 && Number.isFinite(v[0]) && Number.isFinite(v[1]) && Number.isFinite(v[2]);
}

var Vector3 = function (_MathArray) {
  _inherits(Vector3, _MathArray);

  // Creates a new vec3, either empty, or from an array or from values
  function Vector3() {
    var x = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    var y = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    var z = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;

    _classCallCheck(this, Vector3);

    var _this = _possibleConstructorReturn(this, (Vector3.__proto__ || Object.getPrototypeOf(Vector3)).call(this));

    if (Array.isArray(x) && arguments.length === 1) {
      _this.copy(x);
    } else {
      _this.set(x, y, z);
    }
    return _this;
  }

  // fromArray(array) {
  //   if (array instanceof Vector3) {
  //     return array;
  //   }
  //   return new Vector3(...array);
  // }

  _createClass(Vector3, [{
    key: 'set',
    value: function set(x, y, z) {
      vec3_set(this, x, y, z);
      return this.check();
    }

    // Getters/setters
    /* eslint-disable no-multi-spaces, brace-style, no-return-assign */

  }, {
    key: 'length',

    /* eslint-enable no-multi-spaces, brace-style, no-return-assign */

    value: function length() {
      return vec3_length(this);
    }
  }, {
    key: 'distance',
    value: function distance(vector) {
      return vec3_distance(this, vector);
    }
  }, {
    key: 'angle',
    value: function angle(vector) {
      return vec3_angle(this, vector);
    }
  }, {
    key: 'dot',
    value: function dot(vector) {
      return vec3_dot(this, vector);
    }

    // MODIFIERS

  }, {
    key: 'add',
    value: function add() {
      for (var _len = arguments.length, vectors = Array(_len), _key = 0; _key < _len; _key++) {
        vectors[_key] = arguments[_key];
      }

      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = vectors[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var vector = _step.value;

          vec3_add(this, this, vector);
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      return this.check();
    }
  }, {
    key: 'subtract',
    value: function subtract() {
      for (var _len2 = arguments.length, vectors = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        vectors[_key2] = arguments[_key2];
      }

      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = vectors[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var vector = _step2.value;

          vec3_subtract(this, this, vector);
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }

      return this.check();
    }
  }, {
    key: 'multiply',
    value: function multiply() {
      for (var _len3 = arguments.length, vectors = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
        vectors[_key3] = arguments[_key3];
      }

      var _iteratorNormalCompletion3 = true;
      var _didIteratorError3 = false;
      var _iteratorError3 = undefined;

      try {
        for (var _iterator3 = vectors[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
          var vector = _step3.value;

          vec3_multiply(this, this, vector);
        }
      } catch (err) {
        _didIteratorError3 = true;
        _iteratorError3 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion3 && _iterator3.return) {
            _iterator3.return();
          }
        } finally {
          if (_didIteratorError3) {
            throw _iteratorError3;
          }
        }
      }

      return this.check();
    }
  }, {
    key: 'scale',
    value: function scale(_scale) {
      if (Number.isFinite(_scale)) {
        vec3_scale(this, this, _scale);
      } else {
        vec3_multiply(this, this, _scale);
      }
      return this.check();
    }
  }, {
    key: 'negate',
    value: function negate() {
      vec3_negate(this, this);
      return this.check();
    }
  }, {
    key: 'inverse',
    value: function inverse() {
      vec3_inverse(this, this);
      return this.check();
    }
  }, {
    key: 'normalize',
    value: function normalize() {
      vec3_normalize(this, this);
      return this.check();
    }
  }, {
    key: 'cross',
    value: function cross(vector) {
      vec3_cross(this, this, vector);
      return this.check();
    }
  }, {
    key: 'lerp',
    value: function lerp(vector, coeff) {
      vec3_lerp(this, this, vector, coeff);
      return this.check();
    }
  }, {
    key: 'rotateX',
    value: function rotateX(_ref) {
      var radians = _ref.radians,
          _ref$origin = _ref.origin,
          origin = _ref$origin === undefined ? ORIGIN : _ref$origin;

      vec3_rotateX(this, this, origin, radians);
      return this.check();
    }
  }, {
    key: 'rotateY',
    value: function rotateY(_ref2) {
      var radians = _ref2.radians,
          _ref2$origin = _ref2.origin,
          origin = _ref2$origin === undefined ? ORIGIN : _ref2$origin;

      vec3_rotateY(this, this, origin, radians);
      return this.check();
    }
  }, {
    key: 'rotateZ',
    value: function rotateZ(_ref3) {
      var radians = _ref3.radians,
          _ref3$origin = _ref3.origin,
          origin = _ref3$origin === undefined ? ORIGIN : _ref3$origin;

      vec3_rotateZ(this, this, origin, radians);
      return this.check();
    }
  }, {
    key: 'operation',
    value: function operation(_operation) {
      for (var _len4 = arguments.length, args = Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++) {
        args[_key4 - 1] = arguments[_key4];
      }

      _operation.apply(undefined, [this, this].concat(args));
      return this.check();
    }

    // TBD - do we really need these?

  }, {
    key: 'divide',
    value: function divide() {
      for (var _len5 = arguments.length, vectors = Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
        vectors[_key5] = arguments[_key5];
      }

      var _iteratorNormalCompletion4 = true;
      var _didIteratorError4 = false;
      var _iteratorError4 = undefined;

      try {
        for (var _iterator4 = vectors[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
          var vector = _step4.value;

          vec3_divide(this, this, vector);
        }
      } catch (err) {
        _didIteratorError4 = true;
        _iteratorError4 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion4 && _iterator4.return) {
            _iterator4.return();
          }
        } finally {
          if (_didIteratorError4) {
            throw _iteratorError4;
          }
        }
      }

      return this.check();
    }
  }, {
    key: 'scaleAndAdd',
    value: function scaleAndAdd(vector, scale) {
      vec3_scaleAndAdd(this, this, vector, scale);
      return this.check();
    }
  }, {
    key: 'ELEMENTS',
    get: function get() {
      return 3;
    }
  }, {
    key: 'x',
    get: function get() {
      return this[0];
    },
    set: function set(value) {
      return this[0] = checkNumber(value);
    }
  }, {
    key: 'y',
    get: function get() {
      return this[1];
    },
    set: function set(value) {
      return this[1] = checkNumber(value);
    }
  }, {
    key: 'z',
    get: function get() {
      return this[2];
    },
    set: function set(value) {
      return this[2] = checkNumber(value);
    }
  }]);

  return Vector3;
}(MathArray);

export default Vector3;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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


//////////////////
// WEBPACK FOOTER
// ./node_modules/math.gl/dist-es6/vector3.js
// module id = 83
// module chunks = 0